import React from 'react';
import './Home.scss';

const Home = () => {
    return (
        <div>
            <h1>He' lo</h1>
        </div>
    )
}

export default Home
